import { render, staticRenderFns } from "./SettingsThemes.vue?vue&type=template&id=4081b218&"
import script from "./SettingsThemes.vue?vue&type=script&lang=js&"
export * from "./SettingsThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports